{
    angular.module('interfaceModule')
        .controller('QruserModalController',QruserModalController);
    QruserModalController.$inject = ['$scope',"$state",'$stateParams','request.order','alertControl','md5','requestHandler','utils.constant','request.login'];
    function QruserModalController($scope,$state,$stateParams,orderRequest,alertControl,md5,requestHandler,constant,loginRequest) {
        let vm=this;
        $scope.vm=vm;
        let collect={
            'activate':activate,
            'changPassword':changPassword,
            forget:false,

            oldPassword:'',
            'newPassword':'',
            'confirmPassword':'',
            'resultCode':-1
        };
        vm.collect=collect;
        activate();

        function activate(){
            console.log('QruserModalController',$scope.userId);
        }



        //修改密码
        function changPassword() {
            // console.log(collect.oldPassword);
            // console.log(collect.newPassword);
               if (collect.oldPassword.length>0){
                       let params=[{
                           'userid': $scope.userId,
                           'pwd':collect.oldPassword
                       }];
                       let str='userinfo='+JSON.stringify(params);
                   loginRequest.login($scope.userId,encodeURIComponent(collect.oldPassword))
                       .then(function(respone){
                   // requestHandler.simpleRequest(constant.action.usersset,str).then(function (respone) {
                       console.log(respone);
                       console.log(respone[0].result);
                       if (respone[0].result==1){
                               if (collect.newPassword.length>0){
                                       if (collect.newPassword===collect.confirmPassword){
                                           let _data = new Date();
                                           let year = _data.getFullYear(),
                                               month= _data.getMonth() + 1,
                                               data = _data.getDate(),
                                               hour = _data.getHours(),
                                               minutes = _data.getMinutes(),
                                               seconds = _data.getSeconds();
                                           let pwdchangetime = year + '-' + month + '-' + data + ' ' + hour + ':' + minutes + ':' + seconds;
                                           let params=[{
                                               'userid': $scope.userId,
                                               'pwd':md5.createHash(encodeURIComponent(collect.newPassword)),
                                               'pwdchangetime' : pwdchangetime
                                           }];
                                           let str='userinfo='+JSON.stringify(params);
                                           requestHandler.simpleRequest(constant.action.usersset,str).then(function (respone) {
                                               console.log(respone);
                                               if(respone.data[0].result == 1){
                                                   let alert=alertControl.show('',
                                                       '修改密码成功',
                                                       [{
                                                           'title':'确定',
                                                           'action':function(){
                                                               alert.close();
                                                               $scope.$close();
                                                           }
                                                       }]
                                                   );
                                               }else{
                                                   let alert=alertControl.show('',
                                                       '修改密码失败，请重试！',
                                                       [{
                                                           'title':'确定',
                                                           'action':function(){
                                                               alert.close();

                                                           }
                                                       }]
                                                   );
                                               }

                                               // }
                                               // collect.Change();

                                           },function(){
                                                  // alert("修改失败");
                                                   let alert=alertControl.show('',
                                                       '修改失败',
                                                       [{
                                                           'title':'确定',
                                                           'action':function(){
                                                               alert.close();
                                                               $scope.$close();
                                                           }
                                                       }]
                                                   );
                                           });

                                       }else {
                                           // alert('输入的新密码和确认密码不一致');
                                           let alert=alertControl.show('',
                                               '输入的新密码和确认密码不一致',
                                               [{
                                                   'title':'确定',
                                                   'action':function(){
                                                       alert.close();
                                                   }
                                               }]
                                           );
                                       }

                               }else {
                                   let alert=alertControl.show('',
                                       '请输入新密码',
                                       [{
                                           'title':'确定',
                                           'action':function(){
                                               alert.close();
                                               // $scope.$close();
                                           }
                                       }]
                                   );
                               }


                       } else {
                           let alert=alertControl.show('',
                               '输入的旧密码有误',
                               [{
                                   'title':'确定',
                                   'action':function(){
                                       alert.close();
                                       // $scope.$close();
                                   }
                               }]
                           );
                       }
                   },
                   function () {
                               let alert=alertControl.show('',
                                   '请求错误，请重试！',
                                   [{
                                       'title':'确定',
                                       'action':function(){
                                           alert.close();
                                           // $scope.$close();
                                       }
                                   }]
                               );
                    }
                   );
                }else{
                    let alert=alertControl.show('',
                        '请输入旧密码',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                                // $scope.$close();
                            }
                        }]
                    );
                }


        }

    }

}